import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="w-full bg-white">
      <div className="max-w-6xl mx-auto px-4 py-20 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-20">
          
          {/* Contact Details */}
          <div className="space-y-10">
            <div>
              <h1 className="font-serif text-4xl text-purple-900 mb-6">Start the Journey</h1>
              <p className="text-gray-600 text-lg leading-relaxed">
                Whether you have a specific developmental concern or simply want to maximize your child's early potential using the Can Do Method, I am here to help.
              </p>
            </div>

            <div className="space-y-6 text-center md:text-left">
              <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                <div className="bg-stone-50 p-3 rounded-full border border-stone-200">
                  <SafeIcon icon={FiIcons.FiMapPin} className="text-xl text-purple-800" />
                </div>
                <div>
                  <p className="font-bold text-gray-900">Saddleworth & Surrounds</p>
                  <p className="text-gray-600 text-sm">Greater Manchester, Lancashire, Yorkshire, Derbyshire.</p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                <div className="bg-stone-50 p-3 rounded-full border border-stone-200">
                  <SafeIcon icon={FiIcons.FiMail} className="text-xl text-purple-800" />
                </div>
                <div>
                  <p className="font-bold text-gray-900">Email Enquiries</p>
                  <p className="text-gray-600 text-sm">hello@cando-development.co.uk</p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                <div className="bg-stone-50 p-3 rounded-full border border-stone-200">
                  <SafeIcon icon={FiIcons.FiClock} className="text-xl text-purple-800" />
                </div>
                <div>
                  <p className="font-bold text-gray-900">Response Time</p>
                  <p className="text-gray-600 text-sm">I aim to respond to all local enquiries within 24 hours.</p>
                </div>
              </div>
            </div>
            
            <div className="p-6 bg-purple-50 rounded-xl border border-purple-100 italic">
              <h4 className="font-bold text-purple-900 mb-2 not-italic">A Calm Authority</h4>
              <p className="text-sm text-purple-800/80">
                "My goal is to provide a grounded, practical service that makes you feel confident and capable, not overwhelmed by checklists."
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-2xl border border-stone-100">
            {!submitted ? (
              <form onSubmit={handleSubmit} className="space-y-6">
                <h2 className="font-serif text-2xl text-gray-900">Booking Enquiry</h2>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">First Name</label>
                    <input type="text" required className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 transition-all outline-none" />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Last Name</label>
                    <input type="text" required className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 transition-all outline-none" />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Email</label>
                  <input type="email" required className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 transition-all outline-none" />
                </div>

                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Location/Town</label>
                  <input type="text" placeholder="e.g. Delph, Saddleworth" className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 transition-all outline-none" />
                </div>

                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Child's Approximate Age</label>
                  <select className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 transition-all outline-none bg-white">
                    <option>Expecting / Newborn</option>
                    <option>0 - 6 Months</option>
                    <option>6 - 12 Months</option>
                    <option>1 - 3 Years</option>
                    <option>3 - 5 Years</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">How can I support you?</label>
                  <textarea rows="4" className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 transition-all outline-none" placeholder="Tell me a little about your child's current strengths..."></textarea>
                </div>

                <button type="submit" className="w-full bg-purple-800 text-white py-4 rounded-lg font-bold hover:bg-purple-900 transition-all shadow-lg transform hover:-translate-y-1">
                  Send Enquiry
                </button>
              </form>
            ) : (
              <div className="h-full flex flex-col items-center justify-center text-center py-20 px-4">
                <div className="w-20 h-20 bg-purple-50 rounded-full flex items-center justify-center mb-6">
                  <SafeIcon icon={FiIcons.FiCheck} className="text-4xl text-purple-600" />
                </div>
                <h3 className="text-3xl font-serif text-gray-900 mb-4">Message Received</h3>
                <p className="text-gray-600 leading-relaxed">
                  Thank you for reaching out. I look forward to discussing how the Can Do Method can support your family. I'll be in touch within one working day.
                </p>
                <button onClick={() => setSubmitted(false)} className="mt-10 text-purple-800 font-bold hover:underline">
                  Send another message
                </button>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;